const API_BASE = process.env.REACT_APP_API_BASE || "http://localhost:8000";

export async function fetchPlotsByZone(zone) {
    const res = await fetch(`${API_BASE}/plots?zone=${zone}`);
    if (!res.ok) throw new Error(`Failed to fetch plots: ${res.status}`);
    return res.json();
}

export async function fetchBlocksByZone(zone) {
    const res = await fetch(`${API_BASE}/blocks?zone=${zone}`);
    if (!res.ok) throw new Error(`Failed to fetch blocks: ${res.status}`);
    return res.json();
}

export async function fetchBlocks() {
    const res = await fetch(`${API_BASE}/blocks/`);
    if (!res.ok) throw new Error(`Failed to fetch blocks: ${res.status}`);
    return res.json();
}

export async function fetchPlots() {
    const res = await fetch(`${API_BASE}/plots/`);
    if (!res.ok) throw new Error(`Failed to fetch plots: ${res.status}`);
    return res.json();
}

export { API_BASE };
